import {BaseNumberModel} from '@shared/base/base-number-model';

export class RelationArticle extends BaseNumberModel {
  relationNumber: number;
  relationName: string;
  articleNumber: number;
  articleName: string;
  groupId: number;
  groupName: string;
  name: string;
  active: boolean;

  vatId: number;
  piecePrice: number;
}
